import { render, staticRenderFns } from "./SwipePlugin.vue?vue&type=template&id=0b510ea2&scoped=true"
import script from "./SwipePlugin.vue?vue&type=script&lang=ts"
export * from "./SwipePlugin.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./SwipePlugin.vue?vue&type=style&index=0&id=0b510ea2&prod&scoped=true&lang=less")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "0b510ea2",
  null
  ,true
)

export default component.exports